import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, XCircle } from "lucide-react";
import moment from "moment";
import { useBiometricValidation } from "../../Contexts/biometric-validation";
import { getHashToLocalStorage } from "../../Utils/local-storage";
import { cnpjCpfMask, phoneMask } from "../../Utils/ValidationsMasks";
import { Layout } from "../../Components/layout";
import { Button, Col, Row, Spinner } from "react-bootstrap";

import "./styles.css";

export function BiometriaInfo() {
  const navigate = useNavigate();
  const { biometricInfo, biometricInfoLoading, onGetBiometricInfo } =
    useBiometricValidation();

  const hash = getHashToLocalStorage();

  useEffect(() => {
    if (hash) {
      onGetBiometricInfo({ hash });
    }
  }, [hash, onGetBiometricInfo]);

  return (
    <Layout>
      <Row className="row_container">
        <Col className="text-center mb-3">
          <h1 className="title">Detalhes da Solicitação</h1>
        </Col>

        <Col className="d-flex flex-column gap-3 mb-3">
          {biometricInfoLoading ? (
            Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="border px-5 py-3 card_info "
                style={{ backgroundColor: "var(--bg-light-grey)" }}
              >
                <Spinner
                  role="status"
                  animation="grow"
                  style={{ color: "var(--bg-light-grey)" }}
                />
              </div>
            ))
          ) : (
            <div className="d-flex flex-column gap-4">
              {!biometricInfo?.isMaster && (
                <div className="border px-5 py-3 card_info">
                  <span className="card_label">EMPRESA SOLICITANTE</span>
                  <p className="card_text text-truncate m-0">
                    {biometricInfo?.nome_cliente || "---"}
                  </p>
                  <strong className="small">
                    CNPJ: {cnpjCpfMask(biometricInfo?.cnpj_cliente)}
                  </strong>
                </div>
              )}

              {!biometricInfo?.isMaster && (
                <div className="border px-5 py-3 card_info">
                  <span className="card_label">CONTATO</span>
                  <p className="card_text m-0">
                    {phoneMask(biometricInfo?.telefone_cliente) || "---"}
                  </p>
                </div>
              )}

              <div className="border px-5 py-3 card_info">
                <span className="card_label">USUÁRIO SOLICITANTE</span>
                <p className="card_text m-0">
                  {biometricInfo?.nome_usuario || "---"}
                </p>
              </div>

              <div className="border px-5 py-3 card_info">
                <span className="card_label">DATA DA VALIDAÇÃO</span>
                <p className="card_text m-0">
                  {moment(biometricInfo?.data_validacao).format(
                    "DD/MM/YYYY HH:mm",
                  ) || "---"}
                </p>
              </div>
            </div>
          )}
        </Col>

        {!biometricInfoLoading && (
          <Col className="d-flex flex-column gap-3 mt-3">
            <Button
              onClick={() => navigate("/biometria/geolocalizacao")}
              disabled={biometricInfoLoading}
              className="w-100 py-2 d-flex align-items-center justify-content-center gap-2"
              size="lg"
            >
              {biometricInfoLoading ? (
                <>
                  <Spinner role="status" animation="border" size="sm" />{" "}
                  Aguarde...
                </>
              ) : (
                <>
                  Iniciar Identificação
                  <ArrowRight />
                </>
              )}
            </Button>

            <Button
              onClick={() => navigate("/biometria/cancelar")}
              disabled={biometricInfoLoading}
              variant="danger"
              className="w-100 py-2 d-flex align-items-center justify-content-center gap-2"
              size="lg"
            >
              <XCircle />
              Não reconheço este processo
            </Button>
          </Col>
        )}
      </Row>
    </Layout>
  );
}
